import { render, staticRenderFns } from "./KilosInput.vue?vue&type=template&id=bc5a88ca"
import script from "./KilosInput.vue?vue&type=script&lang=js"
export * from "./KilosInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports